// extracted by mini-css-extract-plugin
module.exports = {"copyModalTitle":"CopyParams_copyModalTitle__80DkU","copyModalContent":"CopyParams_copyModalContent__rgEnI"};